import { Component, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

@Component
export class TextBlock extends ThemeComponent {

    //readmore
    @Ref({ required: false }) truncateText!: HTMLElement;
    @Ref({ required: false }) readMore!: HTMLElement;


    init() {
        //readmore fucntionality
        if(this.readMore) {
            this.evaluateTextLength();
            this.readmore();
        }

        window.addEventListener('resize', () => {
            if(this.readMore) {
                this.evaluateTextLength();
            }
        });

    }

    private evaluateTextLength() {
        // Calculate line height and visible height
        const lineHeight = parseFloat(getComputedStyle(this.truncateText).lineHeight);
        const maxLines = 3;
        const maxHeight = lineHeight * maxLines;

        // If the text fits in 3 lines, hide the read more button
        if (this.truncateText.scrollHeight <= maxHeight + 1) { // +1 to avoid rounding issues
            this.readMore.classList.add('visually-hidden');
        }
    }



    private readmore() {
        // Listen for read more click
        this.$listen(this.readMore, 'click', () => {

            // Show full text
            this.truncateText.classList.toggle('truncate');

            // Remove read more button
            this.readMore.classList.toggle('readless');

            if (this.readMore.classList.contains('readless')) {
                this.readMore.innerText = 'Read less';
            } else {
                this.readMore.innerText = 'Read more';
            }
        });
    }

}
